import { useEffect } from 'react';
import { NavLink, Outlet } from 'react-router';
import { Icon, useAuth, useTheme } from '@saas/ui';

const links = [
  { to: '/invoices', label: '帳票', end: true },
  { to: '/invoices/new', label: '新規作成' },
  { to: '/invoices/library', label: '取引ライブラリ' },
  { to: '/invoices/recurring', label: '定期作成' },
  { to: '/invoices/import', label: 'CSV一括作成' },
  { to: '/invoices/payments', label: '入金・消込' },
  { to: '/invoices/statements', label: '合計請求書' },
  { to: '/invoices/closings', label: '締め処理' },
  { to: '/invoices/deliveries', label: '送付履歴' },
  { to: '/invoices/partners', label: '取引先' },
  { to: '/invoices/products', label: '商品リスト' },
  { to: '/invoices/projects', label: '案件' },
  { to: '/invoices/reports/receivables', label: '売掛残高' },
  { to: '/invoices/settings', label: '発行者設定', end: true },
  { to: '/invoices/settings/numbering', label: '付番設定' },
  { to: '/invoices/settings/templates', label: '帳票テンプレート' },
];

/** Invoice workspace has its own navigation and opens from the console in a separate tab. */
export function InvoiceShell() {
  const { me, can } = useAuth();
  const { resolved, toggle } = useTheme();
  useEffect(() => { const previous = document.title; document.title = `請求書 | ${me?.tenant.name ?? 'ooak'}`; return () => { document.title = previous; }; }, [me?.tenant.name]);
  return <div className="min-h-dvh bg-base text-fg">
    <header className="border-b border-line bg-card px-4 py-3">
      <div className="mx-auto flex max-w-[1280px] flex-wrap items-center gap-3">
        <span className="font-serif text-xl font-semibold">ooak <span className="text-fg-secondary">請求書</span></span>
        <span className="text-callout text-fg-secondary">{me?.tenant.name}</span>
        <div className="flex-1" />
        <button type="button" className="min-tap rounded-input px-3 hover:bg-sunken" onClick={toggle} aria-label={resolved === 'dark' ? 'ライトモードに切り替え' : 'ダークモードに切り替え'}><Icon name={resolved === 'dark' ? 'light_mode' : 'dark_mode'} size={20} /></button>
        <a href="/work" className="inline-flex min-tap items-center gap-1 rounded-input px-3 text-callout hover:bg-sunken"><Icon name="open_in_new" size={20} />業務コンソール</a>
      </div>
    </header>
    <div className="mx-auto flex max-w-[1280px] flex-col gap-5 px-4 py-5 md:flex-row">
      <nav aria-label="請求書メニュー" className="flex shrink-0 flex-wrap gap-1 md:w-48 md:flex-col">
        {links.filter((link) => !['/invoices/new', '/invoices/library', '/invoices/recurring', '/invoices/import'].includes(link.to) || can('invoice.document.write.own') || can('invoice.document.write.team') || can('invoice.document.write.all')).filter((link) => link.to !== '/invoices/payments' || can('invoice.payment.read')).filter((link) => link.to !== '/invoices/statements' || (can('invoice.document.read.all') && can('invoice.payment.read'))).filter((link) => link.to !== '/invoices/reports/receivables' || can('invoice.report.read')).filter((link) => link.to !== '/invoices/products' || can('invoice.settings.manage')).filter((link) => link.to !== '/invoices/closings' || (can('invoice.document.read.all') && can('invoice.payment.read'))).filter((link) => link.to !== '/invoices/deliveries' || can('invoice.document.send')).filter((link) => !link.to.startsWith('/invoices/settings') || can('invoice.settings.manage')).map((link) =>
          <NavLink key={link.to} to={link.to} end={link.end} className={({ isActive }) => `min-tap rounded-input px-3 py-2 text-callout ${isActive ? 'bg-brand-subtle font-semibold text-brand' : 'hover:bg-sunken'}`}>{link.label}</NavLink>,
        )}
      </nav>
      <main id="invoice-main" className="min-w-0 flex-1"><Outlet /></main>
    </div>
  </div>;
}
